module.exports = __webpack_public_path__ + "static/bg-pattern-86a566c64a3a67a97a1b731bd816b08f.png";